import React from 'react';
import { PricingCard } from '../PricingCard';
import ReactConfetti from 'react-confetti';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { trackRedditEvent, trackGoogleEvent, trackLinkedInEvent } from '../../ad_tracking/ad_tracking';
import { createStripeCheckoutSession } from '../StripePortalRedirect';

// Parameters for sad end-of-party confetti:
const confettiColors = [
    'rgb(188, 254, 135)',  
    'rgb(169, 107, 254)', 
    'rgb(57, 215, 199)',
    'rgb(18, 10, 180)'
]

const confettiComponent = (
    <ReactConfetti
        width={200}
        height={400}
        colors={confettiColors}
        numberOfPieces={300}
        recycle={false}
        gravity={0.05}
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            zIndex: 2
        }}
    />
);

const adTrackPaidSubscription = () => {
    const value = 25.0;
    const currency = 'USD';
    
    trackRedditEvent('Custom', {
        customEventName: 'Enter Payment Method Post-Trial',
        value: value,  
        currency: currency,
        itemCount: 1,
        products: [{
            id: 'launch_preview',
            name: 'Preview Access',
            category: 'Subscription',
            price: value,
            quantity: 1
        }]
    });

    // This is a second less-precise event that we'll register any time someone kicks off a
    // payment-required flow. It looks like reddit's Ads graphs don't all support the more precise
    // custom event above, so this makes sure we can plot ads to billable conversions. 
    //
    // There shouldn't be any risk of duplication since these events are separately tracked. 
    trackRedditEvent('Purchase');
    
    trackGoogleEvent('conversion', {
        'send_to': 'AW-17124613764/FUoeCJiSutkaEIS90-U_',
        'value': value,
        'currency': currency
    });

    trackLinkedInEvent({ conversion_id: 20129684 });

}

export function TrialEndCard({ isLoading }) {
    const { user } = useAuthenticator();
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);

    const handleSubscribe = async () => {
        setSubscriptionLoading(true);
        try {
            await createStripeCheckoutSession(user.signInUserSession.idToken.payload.sub, 'stripe_launch_preview_trial_price_id');

            adTrackPaidSubscription();

        } catch (error) {
            console.error('Failed to create Stripe checkout session:', error);
        } finally {
            setSubscriptionLoading(false);
        }        
        
    };

    return (
        <PricingCard
            productName="Your free trial has ended."
            description="To continue getting the most nuanced, data-driven company research and analysis available, activate your subscription by adding a payment method. Cancel any time."
            price="$25"
            cycle="month"
            onPurchase={handleSubscribe}
            isLoading={isLoading || subscriptionLoading}
            error={null}
            confettiComponent={confettiComponent}
            buttonText="Add Payment Method"
        />
    );
}

export default TrialEndCard; 